const t = type => `components/await/${type}`

export const SET_LOADING = t('SET_LOADING')
